// extracted by mini-css-extract-plugin
module.exports = {"spinner":"e8baf","spinnerAnimation":"_7c85a","small":"_196be","medium":"b6d73","large":"e5c1f"};